import DataModel from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import {
  FilterId,
  FilterOptionsType,
  MultiSelectFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export class AirbnbConnectionFilter extends MultiSelectFilter<
  ModelRegistry['airbnb-official-connection']
> {
  id = FilterId.airbnbOfficialConnection;
  optionsType = FilterOptionsType.store;
  modelName = 'airbnb-official-connection';
  modelField = 'fullName' as keyof DataModel;

  @cached
  get models(): ModelRegistry['airbnb-official-connection'][] {
    const models = super
      .models as ModelRegistry['airbnb-official-connection'][];

    return models.filter((item) => item.isFullyConnected);
  }
}
